<a
  *ngIf="saveFile?.renderFile?.savemethod === 'dlattr'"
  id="{{ saveFile.uniqid }}"
  (click)="saveDlAttr()"
  download="{{ saveFile.filename }}"
  [href]="bypassSecurityTrustUrl(saveFile?.renderFile?.url)"
  ><sync-icon-button iconName="download" [matTooltip]="'Download'"></sync-icon-button>
</a>
<a
  *ngIf="saveFile?.renderFile?.savemethod === 'msblob'"
  id="{{ saveFile.uniqid }}"
  (click)="msBlobSave(saveFile.renderFile.msblob, saveFile.filename)"
>
  <sync-icon-button iconName="download"></sync-icon-button>
</a>
